import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import {
  BodyText,
  Button,
  Icon,
  theme,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import {
  AccountScreenBorderedSection,
  AccountScreenContainer,
  AccountScreenSection,
  AccountScreenSectionTitle,
  AccountScreenTitle,
} from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import { useSweetpass } from '../../hooks/useSweetpass';
import type { SweetpassMembershipScreenProps } from '../../navigation/AppNavigation.props';

export const SweetpassMembershipScreen = ({
  navigation,
}: SweetpassMembershipScreenProps) => {
  const { t, formatDate } = useLocalizationContext();
  const { isMobile } = useBreakpointHelpers();

  const handlePressMembershipCta = useCallback(() => {
    navigation.navigate('Modal', { screen: 'SweetpassUpgrade' });
  }, [navigation]);

  const { isSweetpassEnabled, isSweetpassFlagLoading } = useSweetpass();

  if (!isSweetpassEnabled && !isSweetpassFlagLoading) {
    return null;
  }

  return (
    <AccountScreenContainer screen="sweetpass-membership">
      <AccountScreenTitle
        visibility="COMPACT"
        title={t('account.sweetpass-membership.title')}
      />

      {/* PAYMENT */}
      <AccountScreenSectionTitle
        title={t('account.sweetpass-membership.membership.title')}
      />
      <AccountScreenSection style={isMobile ? styles.mobileGrow : {}}>
        <AccountScreenBorderedSection style={{ padding: theme.spacing.large }}>
          <BodyText size={1}>
            {t('account.sweetpass-membership.membership.description')}
          </BodyText>
          <BodyText size={3} style={styles.expiresAt}>
            {t('account.sweetpass-membership.membership.since', {
              date: formatDate(new Date()),
            })}
          </BodyText>
          <Button
            style={styles.button}
            palette="lime"
            size="large"
            leftIcon="IconLoyalty"
            rightElement={ArrowElement}
            onPress={handlePressMembershipCta}
          >
            {t('account.sweetpass-membership.membership.cta')}
          </Button>
        </AccountScreenBorderedSection>
      </AccountScreenSection>
    </AccountScreenContainer>
  );
};

const ArrowElement = () => <Icon name="IconArrowRight" />;

const styles = StyleSheet.create({
  mobileGrow: {
    flexGrow: 0,
  },
  expiresAt: {
    paddingTop: theme.spacing.small,
    color: theme.colors.NEUTRAL_2,
  },
  button: {
    marginTop: theme.spacing.large,
    height: 72,
    maxWidth: 340,
    borderRadius: theme.radius.medium,
    ...theme.elevations['4'],
  },
});
